/**
 * 主界面中心组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>	
		
</template>

<script>
	
	export default {
		name: 'PageSearchCar',
		components: {
			
		},
		data() {
			return {
				
			};
		},
		beforeMount(){
			this.$http.get()
			.then((response)=>{
				if(response.data.success){
					if(response.data.content){
						
					}
				}else{
					
				}
			},(response)=>{
				
			})
			.catch((response)=>{
				
			})
		},
		methods:{
			
		}
	};
</script>
<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// PageSearchCar.vue?74535f40